import { v4 as uuid } from "uuid";

/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: uuid(),
    title: "What is Cryptocurrency?",
    creator: "PushkarRaj Thakur",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "7",
    videoCreated: "8",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
  {
    _id: uuid(),
    title: "Basics of CryptoCurrency",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "2",
    videoCreated: "3",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
  {
    _id: uuid(),
    title: "What is NFT?",
    creator: "Business Coach",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "8",
    videoCreated: "7",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
  {
    _id: uuid(),
    title: "All about Cryptos",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "Cryptoprenuer",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "6",
    videoCreated: "5",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
  {
    _id: uuid(),
    title: "Basics of CryptoCurrency",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "5",
    videoCreated: "6",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
  {
    _id: uuid(),
    title: "What is Cryptocurrency?",
    creator: "PushkarRaj Thakur",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "6",
    videoCreated: "4",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
  {
    _id: uuid(),
    title: "What is NFT?",
    creator: "Business Coach",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "4",
    videoCreated: "6",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
  {
    _id: uuid(),
    title: "All about Cryptos",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    creator: "Cryptoprenuer",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "3",
    videoCreated: "2",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
  {
    _id: uuid(),
    title: "Basics of CryptoCurrency",
    creator: "Sentdex",
    description:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    videoImage:
      "https://i.ytimg.com/vi/Pvd1Y0OR2Nk/hqdefault.jpg?sqp=-oaymwEXCNACELwBSFryq4qpAwkIARUAAIhCGAE=&rs=AOn4CLCauoDvtkqaaSlaU5k8W1g-vA1hxQ",
    views: "2",
    videoCreated: "3",
    videoUrl: "https://youtu.be/zj1X59IWLuQ",
  },
];
